import {useEffect, useState} from 'react'
import {getSalesAreaLetter} from '../api/modules/getdatalist'

/**
 * Hook yang digunakan untuk mendapatkan data sales organization
 */
export const useSalesOrganization = (filterByUserSalesOrg = false) => {
  const [salesOrgOptions, setSalesOrgOptions] = useState<{label: string; value: string}[]>([])

  const getSalesOrg = async () => {
    let filters: any[] = []
    if(filterByUserSalesOrg){
      const cred = atob(localStorage.getItem('credential') || "")
      const credential = JSON.parse(cred)
      
      filters = credential.sales_organization?.split("|")
    }

    const res = await getSalesAreaLetter()
    setSalesOrgOptions(
      res.data.data.filter((item: any) => {
        return !filterByUserSalesOrg || filters.includes(item.code)
      }).map((item: {code: string; name: string}) => ({
        label: item.name,
        value: item.code,
      }))
    )
  }
  useEffect(() => {
    getSalesOrg()
  }, [])

  return {salesOrgOptions}
}
